export const WALLET_BUTTONS_TEST_IDS = {
  walletButtons: 'wallet-buttons',
};
